(function () {
  function swiperInit() {
    subSliderInit(true);
    sliderInit(true);
    sliderABTestInit(true);
    popupSliderInit(true);
    // videoSliderInit(true);
  }

  document.addEventListener("shopify:section:load", function (e) {
    swiperInit();
  });

  swiperInit();
})();
